"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import VisuallyHiddenAlt from "@/components/utility/visually-hidden";
import { RefObject, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Confetti from "react-dom-confetti";
type ThankYouDrawerProps = {
  title: string;
  subtitle: string;
  showDrawer: boolean;
  setShowDrawerAction: (value: boolean) => void;
  onCloseAction?: () => void;
};
export default function ThankYouDrawer(t0) {
  const $ = _c(23);
  const {
    title,
    subtitle,
    showDrawer,
    setShowDrawerAction,
    onCloseAction
  } = t0;
  const [showConfetti, setShowConfetti] = useState(false);
  const drawerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== showDrawer) {
    t1 = () => {
      if (showDrawer) {
        setTimeout(() => {
          setShowConfetti(true);
        }, 0);
        setTimeout(() => setShowConfetti(false), 100);
      }
    };
    t2 = [showDrawer];
    $[0] = showDrawer;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DrawerHeader><VisuallyHiddenAlt><DrawerTitle /></VisuallyHiddenAlt></DrawerHeader>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <h2 className="text-2xl font-black tracking-tight md:text-4xl lg:text-5xl">{title}</h2>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== subtitle) {
    t5 = <p className="mt-4 text-center text-sm text-muted-foreground md:text-base">{subtitle}</p>;
    $[6] = subtitle;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onCloseAction) {
    t6 = <DrawerFooter><Button variant="outline" className="mx-auto mt-8 w-fit" onClick={onCloseAction}>Close</Button></DrawerFooter>;
    $[8] = onCloseAction;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <DrawerContent className="mx-auto max-w-5xl" ref={drawerRef}>{t3}<div className="relative mx-auto flex w-full flex-col items-center py-8 lg:pt-16">{t4}{t5}{t6}</div></DrawerContent>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== setShowDrawerAction || $[15] !== showDrawer || $[16] !== t7) {
    t8 = <Drawer open={showDrawer} onOpenChange={setShowDrawerAction}>{t7}</Drawer>;
    $[14] = setShowDrawerAction;
    $[15] = showDrawer;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== showConfetti) {
    t9 = <ConfettiPortal active={showConfetti} drawerRef={drawerRef} />;
    $[18] = showConfetti;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function ConfettiPortal(t0) {
  const $ = _c(14);
  const {
    active,
    drawerRef
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: 0,
      left: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [position, setPosition] = useState(t1);
  let t2;
  if ($[1] !== drawerRef.current) {
    t2 = () => {
      if (drawerRef.current) {
        const rect = drawerRef.current.getBoundingClientRect();
        setPosition({
          top: rect.top + rect.height / 2,
          left: rect.left + rect.width / 2
        });
      }
    };
    $[1] = drawerRef.current;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== active || $[4] !== drawerRef) {
    t3 = [drawerRef, active];
    $[3] = active;
    $[4] = drawerRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (typeof window === "undefined") {
    return null;
  }
  const t4 = `${position.top}px`;
  const t5 = `${position.left}px`;
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = {
      position: "fixed",
      top: t4,
      left: t5,
      transform: "translate(-50%, -50%)",
      pointerEvents: "none",
      zIndex: 9999
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== active) {
    t7 = <Confetti active={active} />;
    $[9] = active;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = createPortal(<div style={t6}>{t7}</div>, document.body);
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}

// Recycled

// 18 Feb 2026

// if (showDrawer) {
//   setShowConfetti(true);
//   const timer = setTimeout(() => setShowConfetti(false), 100);
//   return () => clearTimeout(timer);
// }